import { Calendar01DuotoneRounded } from "@hugeicons-pro/core-duotone-rounded";
import { useLingui } from "@lingui/react/macro";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CalendarProvider } from "~/components/event-calendar/calendar-context";
import { PageHead } from "~/components/ui/page-head";

export const Route = createFileRoute("/_app/podcasts/$channelUid/planning")({
	component: Page,
});

function Page() {
	const { t } = useLingui();

	return (
		<>
			<PageHead
				icon={Calendar01DuotoneRounded}
				title={t`Podcast Planning`}
				subtitle={t`Keep your schedule on track with this calendar view of your podcast episodes.`}
			/>
			<CalendarProvider>
				<Outlet />
			</CalendarProvider>
		</>
	);
}
